<template>
  <v-btn
    class="secondary-button"
    block
    elevation="0"
    v-bind="$attrs"
    @click="$emit('click', $event)"
    @click.stop="$emit('click.stop', $event)"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: 'SecondaryButton',
}
</script>
<style lang="sass">
.secondary-button
  background-color: transparent !important
  border: 1px solid $darkBlue
  border-radius: 10px
  color: $darkBlue !important
  height: 48px !important
  .v-btn__content
    font-size: 18px !important
  &.v-btn.v-btn--disabled.v-btn--has-bg
    background-color: $darkGrey !important
    color: white !important
</style>
